import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { WorkFlowTaskOverdueSummaryRequest } from '../models/form/work-flow-task-overdue-summary-request.model';
import { WorkFlowTaskOverdueSummary } from '../models/form/work-flow-task-overdue-summary.model';
import { WorkFlowTaskSearchRequest } from '../models/form/work-flow-task-search-request.model';
import { WorkFlowTask } from '../models/form/work-flow-task.model';
import { GlobalService } from '../providers/global.service';
import { Page } from '../providers/request/page.type';
import { RequestService } from '../providers/request/request.service';
import { WorkFlowTaskSummary } from '../models/form/work-flow-task-summary.model';
import { WorkFlowTaskOrgOverdueSummarySearchRequest } from '../models/form/work-flow-task-org-overdue-summary-search-request.model';
import { WorkFlowTaskOrgOverdueSummary } from '../models/form/work-flow-task-org-overdue-summary.model';
import { WorkFlowTaskPersonOverdueSummarySearchRequest } from '../models/form/work-flow-task-person-overdue-summary-search-request.model';
import { WorkFlowTaskPersonOverdueSummary } from '../models/form/work-flow-task-person-overdue-summary.model';
import { GetTaskSummaryRequest } from '../models/form/get-task-summary-request.model';

@Injectable({
  providedIn: 'root',
})
export class WorkFlowTaskOverdueService extends RequestService<WorkFlowTask> {
  static PATH = '/work/flow/task/overdue';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, WorkFlowTaskOverdueService.PATH, globalService.debugUrl);
  }

  getTaskSummary(req: GetTaskSummaryRequest) {
    return this.httpClient.post<WorkFlowTaskSummary[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskOverdueService.PATH}/getTaskSummary`,
      req
    );
  }

  organizationSummary(
    req: WorkFlowTaskOrgOverdueSummarySearchRequest,
    month: boolean,
    page?: number,
    size?: number
  ) {
    return this.httpClient.post<Page<WorkFlowTaskOrgOverdueSummary>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskOverdueService.PATH}/summary/org/${
        month ? 'month' : 'day'
      }/search?page=${page ? page : 0}&size=${size ? size : 20}`,
      req
    );
  }

  personSummary(
    req: WorkFlowTaskPersonOverdueSummarySearchRequest,
    month: boolean,
    page?: number,
    size?: number
  ) {
    return this.httpClient.post<Page<WorkFlowTaskPersonOverdueSummary>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskOverdueService.PATH}/summary/person/${
        month ? 'month' : 'day'
      }/search?page=${page ? page : 0}&size=${size ? size : 20}`,
      req
    );
  }

  searchWaitSign(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskOverdueService.PATH}/searchWaitSign?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param
    );
  }

  searchWaitEdit(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskOverdueService.PATH}/searchWaitEdit?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param
    );
  }

  searchWaitReply(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskOverdueService.PATH}/searchWaitReply?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param
    );
  }

  searchWaitCounterSign(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskOverdueService.PATH}/searchWaitCounterSign?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param
    );
  }

  searchWaitRead(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskOverdueService.PATH}/searchWaitRead?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param
    );
  }

  searchWaiting(
    param: WorkFlowTaskSearchRequest,
    page?: number,
    size?: number
  ) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskOverdueService.PATH}/searchWaiting?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param
    );
  }

  searchRead(param: WorkFlowTaskSearchRequest, page?: number, size?: number) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskOverdueService.PATH}/searchRead?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param
    );
  }

  searchDone(param: WorkFlowTaskSearchRequest, page?: number, size?: number) {
    return this.httpClient.post<Page<WorkFlowTask>>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${WorkFlowTaskOverdueService.PATH}/searchDone?page=${
        page ? page : 0
      }&size=${size ? size : 20}`,
      param
    );
  }
}
